<template>
   <v-container fluid style="margin-top: -12px;"> 
      <div class="info-windows">
        <google-map ref="Map" :zoom.sync="zoom" :center.sync="center">
          <google-map-userposition></google-map-userposition>
          <google-map-marker
              :key="index"
              v-for="(marker, index) in markers"
              :title="marker.title"
              :label="marker.label"
              :icon ="marker.icon"
              :position="marker.position"
          />

        </google-map>
      </div>
    </v-container> 

  </template>
<script> 
import BaseModule from '../../common/BaseModule.js'
import api from '../../../api/worktime'

export default {
  name: 'MapsWidget',
  mixins: [BaseModule],
  components: { 

  },
   props: ['config','context'],
  
  data() {
      return {
        isLoading: true,
        zoom: 2,
        center: { lat: 29.093048, lng: -0.84212 },
      markers: [
      ],
      }
  },mounted() {
        this.update();
    },
    watch: {
      context: function() { 
        this.update();
      }
    },
   methods: {
    update() {
       this.$refs.Map.$el.firstChild.style.height="400px";

       let queryContext = {
            workplaceIds: this.context.workplaceIds,
            departmentIds: this.context.departmentIds
        };

        const fields = JSON.parse(this.config.fields);
        let icons = fields.icons?fields.icons:{};

        const me = this;
       api.getWidgetData(this.config.id, queryContext, (res) => {
            me.isLoading=false;
            if (!res || res.length==0) {
              me.markers = [];
              return;
            }

            for (let mkr of res) {
              mkr.position = {
                lat: mkr.lat,
                lng: mkr.lng
              }

              mkr.title = mkr.title?mkr.title:mkr.label;
              mkr.label = me.getFirstLetters(mkr.label);
              if (mkr.icon) {
                mkr.icon = icons[mkr.icon];
              }
              
            }
            me.markers=res;
            me.center = me.markers[0].position;
            me.zoom=14;
            
            me.$nextTick(() => {
              me.ensureMarkersVisible();
            });
        }, err => {
            console.log(err); //TODO: mostrar toast?
            this.isLoading=false;
        })

       
    },getFirstLetters(str) {
        const firstLetters = str
          .split(' ')
          .map(word => word[0])
          .join('');

        return firstLetters;
      },
   ensureMarkersVisible()
      { 
       var bounds = this.$refs.Map.getBounds();
        for (var i = 0; i < this.markers.length; i++) {
           bounds.extend(this.markers[i].position);
        }  
        this.$refs.Map.initialZoom=true;
        this.$refs.Map.fitBounds(bounds);
      }

   },
};
</script>
 